import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAP_LIBRARIES } from '../utils/constants';

const useGoogleMapsLoader = () => {
	const { isLoaded, loadError } = useJsApiLoader({
		googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
		libraries: GOOGLE_MAP_LIBRARIES,
	});

	return { isLoaded, loadError };
};

export default useGoogleMapsLoader;
